import React from 'react';
import { ArrowUpIcon as HeroArrowUpIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ArrowUpIconProps = Omit<IconProps, 'children'>;

export const ArrowUpIcon: React.FC<ArrowUpIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroArrowUpIcon />
        </Icon>
    );
};
